<template>
  <div
    class="row editUsuarioRaiz"
    v-bind:class="{
      editUsuarioRaizMeusDados: propMeusDados && propView !== 'modal',
    }"
  >
    <div
      v-bind:class="[
        propColunas,
        { meusDadosPagina: propMeusDados && propView !== 'modal' },
      ]"
    >
      <header
        v-if="propMeusDados && propView !== 'modal'"
        class="meusDadosCabecalho"
      >
        <div>
          <p>Conta e preferências</p>
          <h1>Meus dados</h1>
          <span>Atualize sua senha, fuso horário e preferências de exibição.</span>
        </div>
        <small v-if="item.email">
          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
          {{ item.email }}
        </small>
      </header>

      <div
        v-if="
          mensagem !== '' && propView !== 'modal' && retornaSite() !== '7live'
        "
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <div
        v-if="retornaSite() == '7live' && propMeusDados && carregando"
        style="margin-bottom: 30px; margin-top: 30px"
      >
        <button type="button" class="btn btn-sm btn-warning">
          Carregando <img src="/assets/ajax-loader.gif" style="" />
        </button>
      </div>

      <div
        v-bind:style="{
          display:
            retornaSite() == '7live' && propMeusDados && !carregando
              ? 'block'
              : 'none',
        }"
        style="margin-top: 25px"
      >
        <div>
          <h3 class="text-secondary"><small>email</small></h3>
          <h3>{{ item.email }}</h3>
        </div>

        <div>
          <h3 class="text-secondary"><small>senha</small></h3>
          <input
            class="form-control"
            v-bind:class="{ 'is-invalid': itemErros.senha.status }"
            type="password"
            v-model="item.senha"
            @keyup="enterSalvar"
            placeholder="nova senha ..."
          />
          <div v-if="itemErros.senha.status" class="invalid-feedback">
            {{ itemErros.senha.mensagem }}
          </div>
        </div>
        <div v-if="mensagem !== '' && propView !== 'modal'">
          <h4 class="text-primary" style="margin-top: 15px">
            <small>Senha alterada</small>
          </h4>
        </div>
        <div style="margin-top: 20px">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="salvarItem()"
          >
            Alterar Senha
          </button>
        </div>
        <div style="margin-top: 20px">
          <h3 class="text-secondary">
            <span
              class="mr-2 text-dark"
              style="cursor: pointer"
              @click="
                item.gmt = item.gmt - 1;
                changeGmt();
              "
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-down-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                /></svg></span
            ><span class="mr-2 prevent-select"><small>GMT</small></span>
            <span
              class="text-dark prevent-select"
              style="cursor: pointer"
              @click="
                item.gmt = item.gmt + 1;
                changeGmt();
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-up-circle"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                />
              </svg>
            </span>
          </h3>
          <h3>
            <span class="mr-1 prevent-select">{{
              item.gmt >= 0 ? "+" : "-"
            }}</span
            ><span class="prevent-select"
              >{{ item.gmt >= 0 ? item.gmt : item.gmt * -1 }}
            </span>
          </h3>
        </div>
        <div
          style="margin-top: 20px"
          v-if="
            retornaTipoUsuario() !== 'Administrador' &&
            retornaTipoUsuario() !== 'Apresentador'
          "
        >
          <h3 class="text-secondary prevent-select"><small>crédito</small></h3>
          <h3 class="prevent-select">€ {{ item.credito }}</h3>
        </div>
        <div
          v-if="
            retornaTipoUsuario() == 'Administrador' ||
            retornaTipoUsuario() == 'Apresentador'
          "
          style="margin-top: 20px"
        >
          <h3 class="text-secondary prevent-select"><small>comissão</small></h3>
          <h3 class="prevent-select">
            € {{ formatCurrency(valorComissaoPendente) }}
          </h3>
        </div>
        <div
          style="margin-top: 20px"
          v-if="
            retornaTipoUsuario() !== 'Administrador' &&
            retornaTipoUsuario() !== 'Apresentador'
          "
        >
          <h3 class="text-secondary prevent-select">
            <small>vencimento</small>
          </h3>
          <h5
            v-if="
              propMeusDados &&
              propVencimento &&
              retornaSite() == '7live' &&
              item.plano !== null
            "
            style="margin-bottom: 20px"
          >
            Seu plano finaliza em {{ formatDateTimeSimple(item.plano.dataFim) }}
          </h5>
          <div
            v-if="
              propMeusDados &&
              propVencimento &&
              retornaSite() == '7live' &&
              item.plano == null
            "
            style="margin-bottom: 20px"
          >
            <h5 style="margin-bottom: 20px">Você não possuí um plano ativo</h5>
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="false && retornaSite() == 'Weddbets' && propMeusDados"
        style="margin-top: 10px"
      >
        <div class="col col-md-12 d-flex justify-content-center">
          <span class="text-center">
            <a
              clsas="d-flex justify-content-center"
              href="https://t.me/Wedd_Bll"
              style="width: 100%; text-decoration: none"
              ><i
                class="fa fa-telegram"
                style="font-size: 36px; color: #0088cc"
              ></i>
              <h5 class="text-secondary" style="min-width: 135px">weddbets</h5>
            </a></span
          ><span class="text-center" style="margin-left: 10px" v-if="false">
            <a
              clsas="d-flex justify-content-center"
              href="https://wa.me/qr/OQN6E6SM2PURM1"
              style="width: 100%; text-decoration: none"
              ><i
                class="fa fa-whatsapp"
                style="font-size: 36px; color: #34af23"
              ></i>
              <h5 style="color: black; min-width: 135px">
                <small>41 99936-4613</small>
              </h5>
            </a></span
          >
        </div>
      </div>
      <Dialog
        :id="propMeusDados ? 'dialogEditMeusDados' : 'dialogEdit'"
        :titulo="item._id ? 'Editar usuário' : 'Novo usuário'"
        ref="dialog"
        class="editUsuarioDialog"
        :modal="
          propView == 'modal' || (retornaSite() == '7live' && propMeusDados)
        "
        :hideHeader="propView !== 'modal'"
        :hideFooter="propMeusDados && propView !== 'modal'"
        tamanho="lg"
      >
        <div class="text-left editUsuarioConteudo">
          <div
            v-if="!propMeusDados && item._id !== ''"
            class="editUsuarioIdentificacao"
          >
            <span class="editUsuarioAvatar">
              <i class="fa fa-user" aria-hidden="true"></i>
            </span>
            <div>
              <strong>{{ item.nome || item.email }}</strong>
              <small v-if="item.nome">{{ item.email }}</small>
            </div>
          </div>

          <nav
            class="editUsuarioAbas"
            v-if="
              retornaSite() !== 'Share' && !propMeusDados && item._id !== ''
            "
            aria-label="Seções do usuário"
          >
            <button
              type="button"
              :class="{ ativo: abaSelecionada == 'dados' }"
              @click="trocarAba('dados')"
            >
              <i class="fa fa-address-card-o" aria-hidden="true"></i>
              Dados
            </button>
            <button
              v-if="retornaSite() === '7live'"
              type="button"
              :class="{ ativo: abaSelecionada == 'creditos' }"
              @click="trocarAba('creditos')"
            >
              <i class="fa fa-credit-card" aria-hidden="true"></i>
              Créditos
            </button>
            <button
              type="button"
              :class="{ ativo: abaSelecionada == 'planos' }"
              @click="trocarAba('planos')"
            >
              <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
              Planos
            </button>
            <button
              v-if="retornaSite() === '7live'"
              type="button"
              :class="{ ativo: abaSelecionada == 'eventos' }"
              @click="trocarAba('eventos')"
            >
              <i class="fa fa-calendar" aria-hidden="true"></i>
              Eventos
            </button>
            <button
              v-if="retornaSite() == 'Weddbets'"
              type="button"
              :class="{ ativo: abaSelecionada == 'indicacoes' }"
              @click="trocarAba('indicacoes')"
            >
              <i class="fa fa-share-alt" aria-hidden="true"></i>
              Indicações
            </button>
            <button
              v-if="retornaSite() == 'Weddbets'"
              type="button"
              :class="{ ativo: abaSelecionada == 'pay' }"
              @click="trocarAba('pay')"
            >
              <i class="fa fa-money" aria-hidden="true"></i>
              Pay
            </button>
          </nav>

          <div
            class="rowDados"
            v-bind:style="{
              display: abaSelecionada == 'dados' ? 'block' : 'none',
            }"
          >
            <div v-if="propMeusDados" class="meusDadosSecaoTitulo">
              Dados de acesso
            </div>
            <div class="row editUsuarioDadosIniciais">
              <div
                class="col-sm-6"
                v-if="
                  !propMeusDados &&
                  retornaSite() !== 'Stream1x2' &&
                  retornaSite() !== '7live'
                "
              >
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label">Site</label>
                  <div class="col-sm-12">
                    <Combo
                      :itens="sites"
                      v-model="item.site"
                      :erro="itemErros.site.status"
                    />
                    <div v-if="itemErros.site.status" class="invalid-feedback">
                      {{ itemErros.site.mensagem }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-sm-6"
                v-if="
                  !propMeusDados &&
                  item._id !== '' &&
                  (retornaSite() == 'Weddbets' ||
                    retornaSite() == 'Bll' ||
                    retornaSite() == 'Stream1x2')
                "
              >
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label">Vencimento</label>
                  <div class="col-sm-12" style="margin-top: 8px">
                    <h6>{{ item.vencimento || "-" }}</h6>
                  </div>
                </div>
              </div>

              <div
                class="col-sm-6"
                v-if="
                  !propMeusDados &&
                  retornaSite() !== '7live' &&
                  retornaSite() !== 'Weddbets' &&
                  retornaSite() !== 'Bll' &&
                  retornaSite() !== 'Stream1x2'
                "
              >
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label">Vencimento</label>
                  <div class="col-sm-12">
                    <input
                      class="form-control"
                      v-bind:class="{
                        'is-invalid': itemErros.vencimento.status,
                      }"
                      type="date"
                      v-model="item.vencimento"
                      @keyup="enterSalvar"
                    />
                    <div
                      v-if="itemErros.vencimento.status"
                      class="invalid-feedback"
                    >
                      {{ itemErros.vencimento.mensagem }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-group row"
              v-if="!propMeusDados && retornaSite() !== '7live'"
            >
              <label class="col-sm-12 col-form-label">Nome</label>
              <div class="col-sm-12">
                <input
                  class="form-control"
                  v-bind:class="{ 'is-invalid': itemErros.nome.status }"
                  type="text"
                  v-model="item.nome"
                  @keyup="enterSalvar"
                />
                <div v-if="itemErros.nome.status" class="invalid-feedback">
                  {{ itemErros.nome.mensagem }}
                </div>
              </div>
            </div>
            <div class="form-group row meusDadosLinha">
              <label class="col-sm-12 col-form-label">Email</label>
              <div class="col-sm-12">
                <input
                  class="form-control"
                  v-bind:class="{ 'is-invalid': itemErros.email.status }"
                  type="text"
                  v-model="item.email"
                  :disabled="propMeusDados"
                  @keyup="enterSalvar"
                />
                <div v-if="itemErros.email.status" class="invalid-feedback">
                  {{ itemErros.email.mensagem }}
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="!propMeusDados">
              <label class="col-sm-12 col-form-label">Tipo de usuário</label>
              <div class="col-sm-12">
                <Combo
                  :itens="$global.tipos_usuarios()"
                  v-model="item.tipoUsuario"
                  :erro="itemErros.tipoUsuario.status"
                />
                <div
                  v-if="itemErros.tipoUsuario.status"
                  class="invalid-feedback"
                >
                  {{ itemErros.tipoUsuario.mensagem }}
                </div>
              </div>
            </div>
            <div class="form-group row meusDadosLinha">
              <label class="col-sm-12 col-form-label">{{
                retornaSite() == "Stream1x2" && propMeusDados
                  ? "Password"
                  : "Senha"
              }}</label>
              <div class="col-sm-12">
                <div
                  v-bind:class="{
                    meusDadosSenhaControle: propMeusDados,
                  }"
                >
                  <input
                    class="form-control"
                    v-bind:class="{ 'is-invalid': itemErros.senha.status }"
                    type="password"
                    v-model="item.senha"
                    @keyup="enterSalvar"
                  />
                  <button
                    v-if="propMeusDados"
                    type="button"
                    class="btn btn-primary meusDadosSenhaBotao"
                    :disabled="!item.senha"
                    @click="salvarItem()"
                  >
                    Alterar senha
                  </button>
                </div>
                <div v-if="itemErros.senha.status" class="invalid-feedback">
                  {{ itemErros.senha.mensagem }}
                </div>
              </div>
            </div>

            <div
              v-if="propMeusDados"
              class="meusDadosSecaoTitulo meusDadosSecaoPreferencias"
            >
              Preferências de exibição
            </div>

            <div
              class="form-group row"
              v-if="!propMeusDados && (retornaSite() == 'Weddbets' || retornaSite() == 'Stream1x2')"
            >
              <div class="col-md-12 col-sm-12">
                <label class="col-form-label">Indicação</label>
                <div
                  v-bind:style="{ display: item.indicacao == '' ? '' : 'none' }"
                >
                  <autocomplete
                    default-value=""
                    :search="filtroIndicacao"
                    :get-result-value="displayFiltroIndicacao"
                    @submit="selecionarFiltroIndicacao"
                    style="width: 100%"
                    ref="inputIndicacao"
                  ></autocomplete>
                </div>
                <div
                  v-bind:style="{
                    display: item.indicacao !== '' ? '' : 'none',
                  }"
                >
                  <button
                    type="button"
                    class="editUsuarioIndicacaoSelecionada"
                    @click="removerFiltroIndicacao()"
                  >
                    {{ item.indicacaoEmail }} ({{
                      item.indicacaoRenovacoesTotal
                    }})
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="!propMeusDados">
              <label class="col-sm-12 col-form-label">Observacao</label>
              <div class="col-sm-12">
                <textarea
                  class="form-control"
                  v-bind:class="{ 'is-invalid': itemErros.observacao.status }"
                  v-model="item.observacao"
                />
                <div
                  v-if="itemErros.observacao.status"
                  class="invalid-feedback"
                >
                  {{ itemErros.observacao.mensagem }}
                </div>
              </div>
            </div>
            <div
              class="form-group row"
              v-if="propMeusDados && propVencimento && retornaSite() == '7live'"
            >
              <label class="col-sm-12 col-form-label text-center"
                >Crédito</label
              >
              <div class="col-sm-12 text-center">€ {{ item.credito }}</div>
            </div>

            <div
              class="meusDadosAssinaturaItem meusDadosVencimento meusDadosLinha"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                item.planos === null
              "
            >
              <div class="row mb-2">
                <label class="col-sm-12 col-form-label text-center"
                  >Vencimento</label
                >
                <div class="col-sm-12 text-center">
                  {{ formatDate(item.vencimento) }}
                </div>
              </div>
            </div>
            <div
              class="form-group row meusDadosAssinaturaItem meusDadosVencimento meusDadosLinha"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                !item.planos === null &&
                item.plano == null
              "
            >
              <label
                v-if="
                  retornaSite() == 'Weddbets' ||
                  retornaSite() == 'Bll' ||
                  retornaSite() == 'Stream1x2'
                "
                label
                class="col-sm-12 col-form-label text-center"
                >{{
                  retornaSite() == "Stream1x2" && propMeusDados
                    ? "Your access expire in"
                    : "Vencimento atual"
                }}</label
              >
              <label
                v-if="retornaSite() == 'EXCLUIDO'"
                label
                class="col-sm-12 col-form-label text-center"
                >Vencimento</label
              >
              <div class="col-sm-12 text-center">-</div>
            </div>
            <div
              class="form-group row meusDadosPreferenciaItem meusDadosPreferenciaGmt meusDadosLinha"
              v-if="
                propMeusDados &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live'
              "
            >
              <label class="col-sm-12 col-form-label text-center">{{
                retornaSite() == "Stream1x2" && propMeusDados
                  ? "Select GMT"
                  : "Selecione o fuso horário GMT"
              }}</label>

              <div class="d-flex justify-content-center">
                <Combo
                  @change="changeGmt()"
                  :itens="[
                    {
                      id: '-12',
                      nome: 'GMT -12:00',
                    },
                    {
                      id: '-11',
                      nome: 'GMT -11:00',
                    },
                    {
                      id: '-10',
                      nome: 'GMT -10:00',
                    },
                    {
                      id: '-9',
                      nome: 'GMT -09:00',
                    },
                    {
                      id: '-8',
                      nome: 'GMT -08:00',
                    },
                    {
                      id: '-7',
                      nome: 'GMT -07:00',
                    },
                    {
                      id: '-6',
                      nome: 'GMT -06:00',
                    },
                    {
                      id: '-5',
                      nome: 'GMT -05:00',
                    },
                    {
                      id: '-4',
                      nome: 'GMT -04:00',
                    },
                    {
                      id: '-3',
                      nome: 'GMT -03:00',
                    },
                    {
                      id: '-2',
                      nome: 'GMT -02:00',
                    },
                    {
                      id: '-1',
                      nome: 'GMT -01:00',
                    },
                    {
                      id: '0',
                      nome: 'GMT +00:00',
                    },
                    {
                      id: '1',
                      nome: 'GMT +01:00',
                    },
                    {
                      id: '2',
                      nome: 'GMT +02:00',
                    },
                    {
                      id: '3',
                      nome: 'GMT +03:00',
                    },
                    {
                      id: '4',
                      nome: 'GMT +04:00',
                    },
                    {
                      id: '5',
                      nome: 'GMT +05:00',
                    },
                    {
                      id: '6',
                      nome: 'GMT +06:00',
                    },
                    {
                      id: '7',
                      nome: 'GMT +07:00',
                    },
                    {
                      id: '8',
                      nome: 'GMT +08:00',
                    },
                    {
                      id: '9',
                      nome: 'GMT +09:00',
                    },
                    {
                      id: '10',
                      nome: 'GMT +10:00',
                    },
                    {
                      id: '11',
                      nome: 'GMT +11:00',
                    },
                    {
                      id: '12',
                      nome: 'GMT +12:00',
                    },
                  ]"
                  v-model="item.gmt"
                />
              </div>
            </div>
            <div
              class="form-group row meusDadosPreferenciaItem meusDadosPreferenciaTemplate meusDadosLinha"
              v-if="
                propMeusDados &&
                ($sitePrincipal == 'Weddbets' ||
                  retornaSite() == 'Weddbets' ||
                  retornaSite() == 'Bll')
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Template</label
              >
              <div class="col-md-12 text-center">
                <button
                  type="button"
                  v-bind:class="{
                    'btn-secondary':
                      $site == 'Weddbets' &&
                      $layoutCliente !== 'WeddbetsNovo',
                    'btn-outline-secondary':
                      $site !== 'Weddbets' ||
                      $layoutCliente == 'WeddbetsNovo',
                  }"
                  class="btn btn-sm"
                  @click="trocarTemplate('Weddbets')"
                  aria-label="Template 1 - Clássico"
                  title="Template 1 - Clássico"
                  :disabled="
                    $site == 'Weddbets' &&
                    $layoutCliente !== 'WeddbetsNovo'
                  "
                >
                  1
                </button>
                <button
                  type="button"
                  v-bind:class="{
                    'btn-secondary': $site == 'Bll',
                    'btn-outline-secondary': $site !== 'Bll',
                  }"
                  class="btn btn-sm ml-1"
                  @click="trocarTemplate('Bll')"
                  :disabled="$site == 'Bll'"
                  aria-label="Template 2 - Alternativo"
                  title="Template 2 - Alternativo"
                >
                  2
                </button>
                <button
                  v-if="
                    $sitePrincipal == 'Weddbets' ||
                    retornaSite() == 'Weddbets'
                  "
                  type="button"
                  v-bind:class="{
                    'btn-secondary': $layoutCliente == 'WeddbetsNovo',
                    'btn-outline-secondary':
                      $layoutCliente !== 'WeddbetsNovo',
                  }"
                  class="btn btn-sm ml-1"
                  @click="trocarTemplate('WeddbetsNovo')"
                  :disabled="$layoutCliente == 'WeddbetsNovo'"
                  aria-label="Template 3 - Novo"
                  title="Template 3 - Novo"
                >
                  3
                </button>
              </div>
            </div>
            <div
              class="form-group row meusDadosPreferenciaItem meusDadosPreferenciaTema meusDadosLinha"
              v-if="
                propMeusDados &&
                (retornaSite() == 'Weddbets' || retornaSite() == 'Bll')
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Tema</label
              >
              <div class="col-md-12 text-center">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  @click="trocarDarkMode(true)"
                >
                  Escuro
                </button>
                <button
                  type="button"
                  class="btn btn-sm ml-1 btn-outline-secondary"
                  @click="trocarDarkMode(false)"
                >
                  Claro
                </button>
              </div>
            </div>

            <div
              v-if="propMeusDados"
              class="meusDadosSecaoTitulo meusDadosSecaoAssinatura"
            >
              Assinatura
            </div>

            <div
              v-if="
                propMeusDados &&
                propVencimento &&
                (retornaSite() == 'Weddbets' || retornaSite() == 'Bll')
              "
              class="meusDadosAssinaturaItem meusDadosRenovacao meusDadosLinha"
            >
              <label class="col-form-label">Renovação</label>
              <div>
                <a class="btn btn-sm btn-success" href="/pay">
                  <i class="fa fa-qrcode" aria-hidden="true"></i>
                  Renovar +30 dias via PIX
                </a>
              </div>
            </div>

            <div
              class="row meusDadosAssinaturaItem meusDadosLinha"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                item.plano !== null
              "
            >
              <label
                v-if="
                  retornaSite() == 'Weddbets' ||
                  retornaSite() == 'Bll' ||
                  retornaSite() == 'Stream1x2'
                "
                label
                class="col-sm-12 col-form-label text-center"
                >{{
                  retornaSite() == "Stream1x2" && propMeusDados
                    ? "Your access expire in"
                    : "Vencimento atual"
                }}</label
              >
              <label
                v-if="retornaSite() == 'EXCLUIDO'"
                label
                class="col-sm-12 col-form-label text-center"
                >Vencimento</label
              >
              <div class="col-sm-12 text-center">
                {{ formatDate(item.plano.dataFim) }}
              </div>
            </div>

            <div
              class="form-group row meusDadosAssinaturaItem meusDadosLinha meusDadosProximosPlanos"
              v-if="
                propMeusDados &&
                propVencimento &&
                retornaSite() !== 'Share' &&
                retornaSite() !== '7live' &&
                item.planosAgendados &&
                item.planosAgendados.length > 0
              "
            >
              <label class="col-sm-12 col-form-label text-center"
                >Próximos planos</label
              >

              <div
                class="col-sm-12 text-center"
                v-for="itemAgendado in item.planosAgendados"
                :key="itemAgendado._id"
                :item="itemAgendado"
              >
                <small
                  >{{ formatDate(itemAgendado.dataInicio) }} -
                  {{ formatDate(itemAgendado.dataFim) }}</small
                >
              </div>
            </div>
            <div class="text-center">
              <ListIndicacoes
                ref="listIndicacoesMeusDados"
                v-if="(retornaSite() == 'Bll' || retornaSite() == 'Stream1x2') && propMeusDados"
              />
            </div>
          </div>

          <div
            class="rowPacotes"
            v-bind:style="{
              display: abaSelecionada == 'planos' ? 'block' : 'none',
            }"
          >
            <div
              class="row"
              style="margin-bottom: 10px"
              v-if="retornaSite() !== 'Share'"
            >
              <div class="col-md-12 col-sm-12 text-center">
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="lancarPlanoCliente()"
                >
                  Lançar
                </button>
              </div>
            </div>

            <ListPlanosCliente
              ref="listPlanosCliente"
              :propUsuario="item._id"
              :propView="'usuario'"
              @item-excluido="calcularVencimento(null)"
            />
          </div>

          <div
            class="rowCreditos"
            v-bind:style="{
              display: abaSelecionada == 'creditos' ? 'block' : 'none',
            }"
          >
            <div class="row" style="margin-bottom: 10px">
              <div class="col-md-12 col-sm-12 text-center">
                <button
                  type="button"
                  class="btn btn-warning btn-sm"
                  @click="lancarCreditoUsuario()"
                >
                  Lançar
                </button>
              </div>
            </div>

            <ListCreditosUsuario
              ref="listCreditosUsuario"
              :propUsuario="item._id"
              :propView="'usuario'"
            />
          </div>

          <div
            class="rowEventos"
            v-bind:style="{
              display: abaSelecionada == 'eventos' ? 'block' : 'none',
            }"
          >
            <ListEventosUsuario
              ref="listEventosUsuario"
              :propUsuario="item._id"
              :propView="'usuario'"
            />
          </div>

          <div
            class="rowIndicacoes text-center"
            v-bind:style="{
              display: abaSelecionada == 'indicacoes' ? 'block' : 'none',
            }"
          >
            <ListIndicacoes
              ref="listIndicacoesUsuario"
              v-if="retornaSite() == 'Weddbets' && !propMeusDados"
              :renovacoes="item.afiliadoRenovacoes"
              @renovacoes="listIndicacoesRenovacoes"
              :usuario="item._id"
              :site="item.site"
              :propView="'usuario'"
            />
          </div>

          <div
            class="row"
            v-bind:style="{
              display: abaSelecionada == 'pay' ? 'block' : 'none',
            }"
          >
            <div class="col col-md-12 col-sm-12">
              <ListPayUsuario ref="listPayUsuario" :propUsuario="item._id" />
            </div>
          </div>

          <div
            v-if="mensagem !== '' && propView == 'modal'"
            class="alert alert-success alert-dismissible fade show"
            role="alert"
          >
            <strong>{{ mensagem }}</strong>
          </div>
        </div>

        <template v-slot:rodape>
          <button
            type="button"
            class="btn btn-secondary"
            v-if="view == 'modal' && propMeusDados == false"
            data-dismiss="modal"
          >
            Fechar
          </button>
          <button
            v-if="
              !propMeusDados &&
              (abaSelecionada == 'dados' || abaSelecionada == 'indicacoes')
            "
            type="button"
            class="btn btn-primary"
            @click="salvarItem()"
          >
            {{
              retornaSite() == "Stream1x2" && propMeusDados
                ? "Save"
                : "Salvar"
            }}
          </button>
        </template>
      </Dialog>
      <EditPlanoCliente
        ref="editPlanoCliente"
        :propUsuario="item._id"
        @fechar="fecharPlanoCliente"
      />
      <EditCreditoUsuario
        ref="editCreditoUsuario"
        :propUsuario="item._id"
        @fechar="fecharCreditoUsuario"
      />
      <section
        v-if="retornaSite() == 'Weddbets' && propMeusDados"
        class="meusDadosIndicacoes"
      >
        <header class="meusDadosCabecalho meusDadosIndicacoesCabecalho">
          <div>
            <p>Programa de indicações</p>
            <h1>Indicações</h1>
            <span>Acompanhe seu link e as indicações realizadas.</span>
          </div>
        </header>
        <div class="meusDadosIndicacoesConteudo">
          <ListIndicacoes
            ref="listIndicacoesMeusDados"
            :propView="'meus-dados'"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";
import ListPlanosCliente from "../lists/ListPlanosCliente.vue";
import EditPlanoCliente from "../edits/EditPlanoCliente.vue";
import ListCreditosUsuario from "../lists/ListCreditosUsuario.vue";
import EditCreditoUsuario from "../edits/EditCreditoUsuario.vue";
import ListPayUsuario from "../lists/ListPayUsuario.vue";

import ListEventosUsuario from "../lists/ListEventosUsuario.vue";
import ListIndicacoes from "../lists/ListIndicacoes.vue";

import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";

export default {
  name: "EditUsuario",
  components: {
    Autocomplete,
    Dialog,
    Combo,
    ListPlanosCliente,
    EditPlanoCliente,
    ListCreditosUsuario,
    EditCreditoUsuario,
    ListEventosUsuario,
    ListIndicacoes,
    ListPayUsuario,
  },
  props: {
    propMeusDados: { type: Boolean, default: false },
    propView: { type: String, default: "modal" },
    propVencimento: { type: Boolean, default: true },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    listIndicacoesRenovacoes(valor) {
      this.item.afiliadoRenovacoes = valor;
    },
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    trocarAba(aba) {
      this.abaSelecionada = aba;
    },
    async trocarTemplate(item) {
      await api.put("/usuario/template", { novoTemplate: item });
      localStorage.setItem("template", item);
      document.location.href = "/";
    },
    async trocarDarkMode(status) {
      localStorage.setItem("darkMode", status);
      document.location.href = "/";
    },
    async carregarItem(id) {
      //* Limpa os campos
      this.novo();

      //* Carrega os dados
      var itemEdit = {};

      if (this.propMeusDados) {
        const response = await api.get("/usuario/meus-dados");
        itemEdit = response.data.item;

        if (itemEdit.valorComissaoPendente) {
          this.valorComissaoPendente = itemEdit.valorComissaoPendente;
        }
      } else {
        const response = await api.get("/usuario/" + id);
        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      this.item._id = itemEdit._id;
      this.item.site = itemEdit.site;
      this.item.email = itemEdit.email;
      this.item.senha = "";

      if (
        Object.prototype.hasOwnProperty.call(itemEdit, "gmt") &&
        Number.isInteger(itemEdit.gmt)
      ) {
        this.item.gmt = itemEdit.gmt;
      } else {
        if (this.retornaSite() == "7live") {
          this.item.gmt = 1;
        } else {
          this.item.gmt = -3;
        }
      }

      if (!this.propMeusDados) {
        this.item.nome = itemEdit.nome;
        this.item.tipoUsuario = itemEdit.tipoUsuario;
        this.item.observacao = itemEdit.observacao;

        if (itemEdit.indicacao && itemEdit.indicacao._id) {
          this.item.indicacao = itemEdit.indicacao._id;
          this.item.indicacaoEmail = itemEdit.indicacao.email;
          this.item.indicacaoRenovacoes = itemEdit.indicacaoRenovacoes;
          this.item.indicacaoRenovacoesTotal =
            itemEdit.indicacaoRenovacoesTotal;
        }

        this.item.afiliadoRenovacoes = itemEdit.afiliadoRenovacoes
          ? itemEdit.afiliadoRenovacoes
          : "1";

        this.$refs.listPlanosCliente.carregarItensUsuario(itemEdit._id);
        this.$refs.listCreditosUsuario.carregarItensUsuario(itemEdit._id);
        this.$refs.listEventosUsuario.carregarItensUsuario(itemEdit._id);
      } else {
        if (itemEdit.planos.length > 0) {
          this.item.planos = itemEdit.planos;
        }
      }

      if (
        !this.propMeusDados &&
        (this.retornaSite() == "Weddbets" ||
          this.retornaSite() == "Bll" ||
          this.retornaSite() == "Stream1x2")
      ) {
        await this.calcularVencimento(itemEdit);
      } else {
        var arrVencimento = itemEdit.vencimento.toString().split("T");

        if (arrVencimento.length > 0) {
          this.item.vencimento = arrVencimento[0];
        } else {
          this.item.vencimento = "";
        }
      }

      if (itemEdit.credito) {
        this.item.credito = itemEdit.credito;
      }

      if (itemEdit.plano) {
        this.item.plano = itemEdit.plano;
      }

      if (itemEdit.planosAgendados) {
        this.item.planosAgendados = itemEdit.planosAgendados;
      }

      if (this.retornaSite() == "Weddbets" && !this.propMeusDados) {
        this.$refs.listIndicacoesUsuario.filtroUsuarioIndicacao = itemEdit._id;
        this.$refs.listIndicacoesUsuario.carregarIndicacoes();

        this.$refs.listPayUsuario.filtroUsuario = itemEdit._id;
        this.$refs.listPayUsuario.carregarItens();
      }

      if (this.retornaSite() == "Weddbets" && this.propMeusDados) {
        this.$refs.listIndicacoesMeusDados.carregarIndicacoes();
      }
    },
    async calcularVencimento(itemEdit) {
      if (itemEdit == null) {
        const response = await api.get("/usuario/" + this.item._id);

        //* Verifica se econtrou
        if (response.data.itens.length > 0) {
          itemEdit = response.data.itens[0];
        }
      }

      if (itemEdit.idx_planosUltimo) {
        if (itemEdit.idx_planosCorrente) {
          this.item.vencimento = this.formatDate(
            itemEdit.idx_planosCorrente.dataFim
          );
        } else {
          this.item.vencimento = this.formatDate(
            itemEdit.idx_planosUltimo.dataFim
          );
        }

        if (
          itemEdit.idx_planosProximo &&
          itemEdit.idx_planosProximo.length > 0
        ) {
          this.item.vencimento =
            this.item.vencimento +
            " ... " +
            this.formatDate(
              itemEdit.idx_planosProximo[itemEdit.idx_planosProximo.length - 1]
                .dataFim
            );
        }
      } else {
        this.item.vencimento = this.formatDate(itemEdit.vencimento);
      }
    },
    async salvarItem() {
      this.mensagem = "";
      this.itemErros = util.errosLimpar(this.itemErros);

      if (this.item.email) {
        this.item.email = this.item.email.toLowerCase();
      }

      var apiRequest;

      var body = this.item;

      if (body.senha == "") {
        delete body.senha;
      }

      if (this.propMeusDados) {
        body.meusDados = true;
      }

      if (this.item._id == "") {
        apiRequest = await api.post("/usuario", body);
      } else {
        apiRequest = await api.put("/usuario/" + this.item._id, body);
        //console.log(apiRequest.data);
      }

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);
      } else {
        if (this.item._id === "") {
          await this.carregarItem(apiRequest.data._id);
          this.$emit("save-item", this.item);
        } else {
          this.mensagem = this.propMeusDados
            ? "Senha alterada com sucesso!"
            : "Usuário alterado com sucesso!";
          if (this.propMeusDados) {
            this.$set(this.item, "senha", "");
          }
          this.$emit("save-item", this.item);
        }
      }
    },
    async changeGmt() {
      await api.put("/usuario/gmt", { gmt: parseInt(this.item.gmt) });
    },
    async abrir() {
      this.$refs.dialog.abrir();
    },
    async fechar() {
      this.$refs.dialog.fechar();
    },
    async novo() {
      this.mensagem = "";

      this.$set(this.item, "_id", "");
      this.$set(this.item, "site", this.retornaSite());
      this.$set(this.item, "nome", "");
      this.$set(this.item, "email", "");
      this.$set(
        this.item,
        "tipoUsuario",
        this.propMeusDados ? "" : "Assinante"
      );
      this.$set(this.item, "vencimento", "");
      this.$set(this.item, "gmt", this.retornaSite() == "7live" ? 0 : -3);
      this.$set(this.item, "credito", 0);
      this.$set(this.item, "plano", null);
      this.$set(this.item, "planos", null);
      this.$set(this.item, "observacao", "");

      this.$set(this.item, "senha", "");
      this.$set(this.item, "indicacao", "");
      this.$set(this.item, "indicacaoEmail", "");
      this.$set(this.item, "indicacaoRenovacoes", 0);
      this.$set(this.item, "indicacaoRenovacoesTotal", 1);
      this.$set(this.item, "afiliadoRenovacoes", "1");
      this.itemErros = util.errosLimpar(this.itemErros);

      this.$refs.listPlanosCliente.limpar();

      if (this.$refs.inputIndicacao) {
        this.$refs.inputIndicacao.value = "";
      }

      this.abaSelecionada = "dados";
      this.valorComissaoPendente = 0;
    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
    formatDate(data) {
      if (!data || data == "-") {
        return "-";
      }
      return util.formatDate(data);
    },
    emailMaskHide(email) {
      return util.emailMaskHide(email);
    },
    formatDateTimeSimple(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDateTimeSimple(data);
    },
    formatCurrency(data) {
      return util.formatCurrency(data);
    },
    lancarPlanoCliente() {
      this.$refs.dialog.fechar();
      this.$refs.editPlanoCliente.abrir();
    },
    lancarCreditoUsuario() {
      this.$refs.dialog.fechar();
      this.$refs.editCreditoUsuario.abrir();
    },
    fecharPlanoCliente() {
      this.$refs.listPlanosCliente.carregarItensUsuario(this.item._id);
      this.calcularVencimento(null);
      this.$refs.dialog.abrir();
    },
    fecharCreditoUsuario() {
      this.$refs.listCreditosUsuario.carregarItensUsuario(this.item._id);
      this.$refs.dialog.abrir();
    },
    selecionarFiltroIndicacao(result) {
      this.item.indicacao = result._id;
      this.item.indicacaoEmail = result.email;
      this.item.indicacaoRenovacoes = 0;
      this.item.indicacaoRenovacoesTotal = 1;
    },
    removerFiltroIndicacao() {
      this.item.indicacao = "";
      this.item.indicacaoEmail = "";
      this.item.indicacaoRenovacoes = 0;
      this.item.indicacaoRenovacoesTotal = 1;
    },
    filtroIndicacao(input) {
      //if (this.planos.length == 0) {
      //  return [];
      //}

      var filtros = "?_limit=10&_page=1";

      if (input !== "") {
        filtros += "&_all=" + input;
      }

      filtros += "&site=" + this.item.site;

      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([]);
        }

        api.get("/usuario" + filtros).then((response) => {
          if (!response.data.erro) {
            resolve(response.data.itens);
          }
        });
      });
    },
  },
  async mounted() {
    this.sites.push({
      id: this.retornaSite(),
      nome:
        this.retornaSite() == "Stream1x2"
          ? "Blink Cast Win"
          : this.retornaSite(),
    });

    if (this.retornaSite() == "Weddbets") {
      this.sites.push({ id: "Bll", nome: "Bll" });
    }

    await this.novo();

    if (this.propMeusDados) {
      await this.carregarItem(0);
    }

    this.view = this.propView;

    this.carregando = false;
  },
  computed: {},
  data: function () {
    return {
      item: {
        _id: "",
        site: "",
        nome: "",
        email: "",
        tipoUsuario: "",
        vencimento: "",
        observacao: "",
        gmt: 0,
        credito: 0,
        plano: null,
        planos: null,
        planosAgendados: Array(),
        senha: "",
        indicacao: "",
        indicacaoEmail: "",
        indicacaoRenovacoes: 0,
        indicacaoRenovacoesTotal: 1,
        afiliadoRenovacoes: "1",
      },
      itemErros: {
        site: { status: false, mensagem: "" },
        nome: { status: false, mensagem: "" },
        email: { status: false, mensagem: "" },
        tipoUsuario: { status: false, mensagem: "" },
        vencimento: { status: false, mensagem: "" },
        observacao: { status: false, mensagem: "" },
        senha: { status: false, mensagem: "" },
        indicacao: { status: false, mensagem: "" },
      },
      sites: [],
      tiposUsuario: [],
      abaSelecionada: "dados",
      view: "",
      mensagem: "",
      valorComissaoPendente: 0,
      carregando: true,
      displayFiltroIndicacao(result) {
        return result.email;
      },
    };
  },
};
</script>

<style>
.editUsuarioRaizMeusDados {
  margin-left: 0;
  margin-right: 0;
}

.meusDadosPagina {
  flex: 0 0 100%;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 1180px;
  padding: 26px 16px 48px;
  text-align: left;
}

.meusDadosCabecalho {
  align-items: flex-end;
  border-bottom: 1px solid #dfe3e6;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  padding: 0 2px 15px;
}

.meusDadosCabecalho p {
  color: #65717a;
  font-size: 10px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: uppercase;
}

.meusDadosCabecalho h1 {
  color: #242a2f;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.1;
  margin: 0;
}

.meusDadosCabecalho span {
  color: #6f7880;
  display: block;
  font-size: 11px;
  margin-top: 6px;
}

.meusDadosCabecalho > small {
  align-items: center;
  background: #f1f3f5;
  border: 1px solid #d9dee2;
  border-radius: 3px;
  color: #525c64;
  display: inline-flex;
  font-size: 10px;
  gap: 6px;
  max-width: 320px;
  overflow: hidden;
  padding: 7px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meusDadosPagina > .editUsuarioDialog .modal-dialog {
  margin: 0 auto !important;
  max-width: none;
  width: 100%;
}

.meusDadosPagina > .editUsuarioDialog .modal-content {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.meusDadosPagina > .editUsuarioDialog .modal-body {
  padding: 0;
}

.meusDadosPagina > .editUsuarioDialog .modal-footer {
  background: #f7f8f9;
  border-bottom: 1px solid #dfe3e6;
  border-top: 1px solid #dfe3e6;
  margin-top: 10px;
  padding: 10px 14px;
}

.meusDadosPagina .rowDados {
  display: grid !important;
  gap: 0;
  grid-template-columns: minmax(0, 1fr);
  max-width: none;
  width: 100%;
}

.meusDadosPagina .editUsuarioConteudo .rowDados {
  max-width: none;
}

.meusDadosPagina .rowDados > * {
  min-width: 0;
}

.meusDadosPagina .rowDados > .editUsuarioDadosIniciais {
  display: none;
}

.meusDadosPagina .rowDados > .meusDadosSecaoTitulo {
  grid-column: 1;
}

.meusDadosSecaoTitulo {
  border-bottom: 1px solid #dfe3e6;
  color: #4a5862;
  font-size: 10px;
  font-weight: 700;
  margin: 18px 0 0;
  padding-bottom: 8px;
  text-transform: uppercase;
}

.meusDadosPagina .rowDados > .meusDadosSecaoTitulo:first-child {
  margin-top: 4px;
}

.meusDadosPagina .rowDados > .form-group.row {
  margin-left: 0;
  margin-right: 0;
}

.meusDadosPagina .rowDados > .form-group.row > [class*="col-"] {
  padding-left: 0;
  padding-right: 0;
}

.meusDadosPagina .meusDadosLinha {
  align-items: center;
  border-bottom: 1px solid #e3e7ea;
  column-gap: 24px;
  display: grid;
  grid-template-columns: minmax(170px, 220px) minmax(0, 1fr);
  margin: 0 !important;
  min-height: 58px;
  padding: 11px 2px !important;
  width: 100%;
}

.meusDadosPagina .meusDadosLinha > .col-form-label,
.meusDadosPagina .meusDadosLinha > .row > .col-form-label {
  margin: 0;
  padding: 0;
}

.meusDadosPagina .meusDadosLinha > [class*="col-"],
.meusDadosPagina .meusDadosLinha > .row > [class*="col-"] {
  min-width: 0;
  padding-left: 0;
  padding-right: 0;
}

.meusDadosPagina .meusDadosLinha > .row {
  align-items: center;
  column-gap: 24px;
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: minmax(170px, 220px) minmax(0, 1fr);
  margin: 0 !important;
  width: 100%;
}

.meusDadosPagina .rowDados .text-center {
  text-align: left !important;
}

.meusDadosPagina .rowDados .justify-content-center {
  justify-content: flex-start !important;
}

.meusDadosPagina .rowDados .form-control {
  width: 100%;
}

.meusDadosPagina .meusDadosSenhaControle {
  align-items: stretch;
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(0, 1fr) auto;
}

.meusDadosPagina .meusDadosSenhaBotao {
  border-radius: 3px;
  font-size: 11px;
  min-width: 112px;
  padding-left: 13px;
  padding-right: 13px;
  white-space: nowrap;
}

.meusDadosPagina .meusDadosSecaoPreferencias {
  order: 10;
}

.meusDadosPagina .meusDadosPreferenciaItem {
  background: transparent;
}

.meusDadosPagina .meusDadosPreferenciaGmt {
  order: 20;
}

.meusDadosPagina .meusDadosPreferenciaTemplate {
  order: 21;
}

.meusDadosPagina .meusDadosPreferenciaTema {
  order: 22;
}

.meusDadosPagina .meusDadosPreferenciaGmt .d-flex {
  justify-content: flex-start !important;
  width: 100%;
}

.meusDadosPagina .meusDadosPreferenciaGmt .form-control {
  max-width: 230px;
}

.meusDadosPagina .meusDadosPreferenciaTemplate > div,
.meusDadosPagina .meusDadosPreferenciaTema > div {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.meusDadosPagina .meusDadosPreferenciaTemplate .btn,
.meusDadosPagina .meusDadosPreferenciaTema .btn {
  margin-left: 0 !important;
}

.meusDadosPagina .meusDadosSecaoAssinatura {
  order: 30;
}

.meusDadosPagina .meusDadosAssinaturaItem {
  order: 40;
}

.meusDadosPagina .meusDadosRenovacao {
  align-self: start;
}

.meusDadosPagina .meusDadosRenovacao .btn {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

.meusDadosPagina .meusDadosProximosPlanos > div {
  grid-column: 2;
}

.meusDadosIndicacoes {
  margin: 30px auto 0;
  width: 100%;
  text-align: left;
}

.meusDadosIndicacoesCabecalho {
  justify-content: center;
  margin-bottom: 0;
  text-align: center;
}

.meusDadosIndicacoesCabecalho > div {
  max-width: 680px;
  width: 100%;
}

.meusDadosIndicacoesConteudo {
  margin: 0 auto;
  max-width: 680px;
  padding: 14px 0 24px;
  width: 100%;
}

.meusDadosIndicacoesConteudo > div {
  text-align: center;
}

.meusDadosIndicacoesConteudo .row {
  margin-left: 0;
  margin-right: 0;
}

.meusDadosIndicacoesConteudo .list-group-item {
  text-align: left;
}

.meusDadosIndicacoes h5 {
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.meusDadosIndicacoes .row > .col-12 {
  padding-left: 0;
  padding-right: 0;
}

.meusDadosIndicacoes .btn-sm {
  border-radius: 3px;
  font-size: 10px;
}

.editUsuarioDialog .modal-dialog {
  max-width: 1120px;
  width: calc(100% - 32px);
}

.editUsuarioDialog .modal-header {
  align-items: center;
  background: #f1f3f5;
  border-bottom: 1px solid #ced4da;
  border-top: 4px solid #3f464d;
  padding: 10px 16px;
}

.editUsuarioDialog .modal-title {
  color: #252b30;
  font-size: 16px;
  font-weight: 600;
}

.editUsuarioDialog .modal-body {
  padding: 14px 18px 6px;
}

.editUsuarioDialog .modal-footer {
  border-top: 1px solid #dee2e6;
  padding: 9px 16px;
}

.editUsuarioDialog .modal-footer .btn {
  border-radius: 3px;
  font-size: 12px;
  min-width: 86px;
  padding: 6px 12px;
}

.editUsuarioIdentificacao {
  align-items: center;
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  min-height: 38px;
}

.editUsuarioAvatar {
  align-items: center;
  background: #e7ebee;
  border: 1px solid #d4dade;
  border-radius: 50%;
  color: #4e5962;
  display: flex;
  flex: 0 0 34px;
  height: 34px;
  justify-content: center;
}

.editUsuarioIdentificacao > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.editUsuarioIdentificacao strong {
  color: #30373d;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.editUsuarioIdentificacao small {
  color: #737c83;
  font-size: 10px;
  margin-top: 2px;
}

.editUsuarioAbas {
  border-bottom: 1px solid #d9dee2;
  display: flex;
  margin: 0 0 14px;
  overflow-x: auto;
}

.editUsuarioAbas button {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  color: #69737b;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
}

.editUsuarioAbas button:hover {
  background: #f5f6f7;
  color: #30373d;
}

.editUsuarioAbas button.ativo {
  border-bottom-color: #e3ad55;
  color: #293138;
}

.editUsuarioAbas button:focus-visible {
  background: #eef1f3;
  outline: 0;
}

.editUsuarioConteudo .rowDados {
  margin: 0 auto;
  max-width: 900px;
  padding-top: 2px;
}

.editUsuarioConteudo .form-group {
  margin-bottom: 11px;
}

.editUsuarioConteudo .col-form-label {
  color: #4e5860;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  padding-bottom: 4px;
  padding-top: 0;
}

.editUsuarioConteudo .form-control,
.editUsuarioConteudo .input-group-text {
  border-radius: 3px;
  font-size: 12px;
  min-height: 34px;
}

.editUsuarioConteudo textarea.form-control {
  min-height: 78px;
}

.editUsuarioConteudo .autocomplete-input {
  border-color: #ced4da;
  border-radius: 3px;
  font-size: 12px;
  min-height: 34px;
  padding-bottom: 6px;
  padding-top: 6px;
}

.editUsuarioIndicacaoSelecionada {
  background: #f4f6f7;
  border: 1px solid #cdd3d8;
  border-radius: 3px;
  color: #355f7a;
  font-size: 11px;
  min-height: 34px;
  padding: 6px 10px;
  text-align: left;
  width: 100%;
}

.editUsuarioIndicacaoSelecionada:hover {
  background: #e9edf0;
}

.editUsuarioConteudo .rowPlanos,
.editUsuarioConteudo .rowPacotes,
.editUsuarioConteudo .rowCreditos,
.editUsuarioConteudo .rowEventos,
.editUsuarioConteudo .rowIndicacoes {
  padding-top: 2px;
}

.editUsuarioConteudo .btn-sm {
  border-radius: 3px;
  font-size: 11px;
  min-height: 28px;
  padding: 4px 9px;
}

@media (max-width: 767px) {
  .meusDadosPagina {
    padding: 18px 8px 36px;
  }

  .meusDadosCabecalho {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .meusDadosCabecalho h1 {
    font-size: 22px;
  }

  .meusDadosCabecalho > small {
    max-width: 100%;
  }

  .meusDadosPagina .rowDados {
    grid-template-columns: 1fr;
  }

  .meusDadosPagina .rowDados > .meusDadosSecaoTitulo {
    grid-column: 1;
  }

  .meusDadosPagina .meusDadosLinha,
  .meusDadosPagina .meusDadosLinha > .row {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 7px;
  }

  .meusDadosPagina .meusDadosProximosPlanos > div {
    grid-column: 1;
  }

  .meusDadosPagina .meusDadosSenhaControle {
    grid-template-columns: minmax(0, 1fr);
  }

  .meusDadosPagina .meusDadosSenhaBotao {
    justify-self: start;
  }

  .editUsuarioDialog .modal-dialog {
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 16px);
  }

  .editUsuarioDialog .modal-body {
    padding-left: 12px;
    padding-right: 12px;
  }

  .editUsuarioAbas button {
    padding-left: 9px;
    padding-right: 9px;
  }
}
</style>
